import { motion } from "framer-motion";

export const PageHeader = ({ overline, title, sub, testId = "page" }) => (
  <section className="relative overflow-hidden border-b border-gray-200 bg-fog pb-16 pt-40 md:pb-24 md:pt-52" data-testid={`${testId}-header`}>
    <div className="pointer-events-none absolute -right-32 top-0 h-[380px] w-[380px] rounded-full bg-gold/10 blur-[150px]" />
    <div className="relative mx-auto max-w-7xl px-5 md:px-8">
      <motion.p
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="flex items-center gap-3 font-mono text-xs uppercase tracking-[0.3em] text-gold-deep"
        data-testid={`${testId}-overline`}
      >
        <span className="h-px w-8 bg-gold" />
        {overline}
      </motion.p>
      <div className="mt-6 overflow-hidden">
        <motion.h1
          initial={{ y: "105%" }}
          animate={{ y: 0 }}
          transition={{ duration: 0.9, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-4xl font-heading text-4xl font-bold leading-[1.05] tracking-tight text-navy md:text-6xl"
          data-testid={`${testId}-title`}
        >
          {title}
        </motion.h1>
      </div>
      {sub && (
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.35 }}
          className="mt-6 max-w-2xl text-base leading-relaxed text-gray-600 md:text-lg"
          data-testid={`${testId}-sub`}
        >
          {sub}
        </motion.p>
      )}
    </div>
  </section>
);
